import React from 'react'
import BannerCreate from '../banner_components/banner_create'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className='content-wrapper w-75 bg-white p-5'>
                    <div>
                        <h2>Create Banner</h2>
                        <BannerCreate />
                    </div>


                </div>
            </div>




        </div>
    )
}
